import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));

// Initialize MSAL, handle any pending redirects, then render
msalInstance.initialize().then(() => {
  // Handle the redirect response (if any) before rendering
  msalInstance.handleRedirectPromise()
    .then((response) => {
      if (response) {
        console.log('Azure AD redirect response received:', response.account?.username);
        // The response will be picked up by useAuth via MSAL's event system
      }
    })
    .catch((error) => {
      console.error('Azure AD redirect error:', error);
    })
    .finally(() => {
      root.render(
        <React.StrictMode>
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </React.StrictMode>
      );
    });
});

